export interface NativeContentProtectionEvent {
  requestId: string;
  integrationId: string;
  keySystemId: string;
}
